import React from 'react';
import { useHistory } from "react-router-dom";
import {Box, Grid, Button, Link} from '@material-ui/core';
import axios from 'axios';
import LoadingButton from '@mui/lab/LoadingButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
//import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import TextField from '@mui/material/TextField';
import {MetaTags} from 'react-meta-tags';
import {API_URL,WHITE_LABEL_LOGO_URL} from '../utils/EnvVars';
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';
import Cookies from 'js-cookie';
import { saveCourseRating } from '../services/saveCourseRating';
// import { useDispatch } from 'react-redux';
// import { addUser } from '../store/user.actions';
// import { selectCourse } from '../store/course.actions';
// import { setMyCourses } from '../store/mycourses.actions';
// import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setTopicTreeTest, setTopicListTest, setSmartLearning, setMockTest } from '../store/data.actions';

  export default function Execute() {	
	let history = useHistory();
	const [userId, setUserId] = React.useState("");
	const [password, setPassword] = React.useState("");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");
	const [loginWith, setLoginWith] = React.useState('password');

	const authResult = new URLSearchParams(window.location.search); 
	const force = authResult.get('force');
	const deviceType = authResult.get('device_type');

	var vertical='top',horizontal='center';

	if(!force && localStorage.getItem('etlStudentObj')!==null){
		history.push("dashboard");
	}

	function hideAlert(){
		setShowAlert(false);
	}

	function login(){
		///alert('Login Now');
		if(!userId){
			setShowAlert(true);
			setAlertMessage(loginWith==='password'?"Enter your user-id.":"Enter your mobile.");			
			return false;

		}else if(loginWith==='otp' && userId && isNaN(userId)){
			setShowAlert(true);
			setAlertMessage("Enter valid mobile number.");			
			return false;	

		}else if(!password){
			setShowAlert(true);
			setAlertMessage("Enter your password.");			
			return false;	

		}else if(loginWith==='otp'){ // Login with OTP *************************

			document.getElementById('waitloginbtnid').style.display='';
			document.getElementById('loginbtnid').style.display='none';
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
				}
			};		  
			const data = new FormData();
			data.append('mobile', userId);			
			axios.post(API_URL+'/app/verify-mobile-send-otp', data, axiosHeader)
			.then((response) => {
				//console.log("RESPONSE RECEIVED: ", response);
				if(response && response.data && response.data.responseTxt==="sent_otp"){	
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					localStorage.setItem("otploginjson", JSON.stringify({token:response.data.obj.token}));
					history.push("loginwithotp");

				}else if(response && response.data && response.data.responseTxt==="mobile_not_exists"){
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage(userId+" mobile number is invalid");			
					return false;	
				}else{
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Something wrong, Try after sometime.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})


		}else{ // Login with Password *************************
			document.getElementById('waitloginbtnid').style.display='';
			document.getElementById('loginbtnid').style.display='none';
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
				}
			};		  
			const data = new FormData();
			data.append('userId', userId);
			data.append('password', password);
			data.append('device', 'web');
			axios.post(API_URL+'/app/login', data, axiosHeader)
			.then(async (response) => {
				//console.log("RESPONSE RECEIVED: ", response);
				//document.writeln(JSON.stringify(response.data));
				if(response && response.data && response.data.responseTxt==="success"){	

					Cookies.set("accountDetails", JSON.stringify({
						sid: response?.data?.obj?.studentId,
						studentId: response?.data?.obj?.studentId,
						loginId: response?.data?.obj?.loginId,
						token: response?.data?.obj?.token,
						studentName: response?.data?.obj?.studentName,
						mobile: response?.data?.obj?.phoneNo,
						email: response?.data?.obj?.emailId
					}))
					Cookies.set("token", `"${response?.data?.obj?.token}"`)
					localStorage.setItem("etlStudentObj", JSON.stringify(response.data.obj));
					
					if(response.data.obj.openedCourse!=null && response.data.obj.openedCourse>0){
						localStorage.setItem("etlSelectCourse", response.data.obj.openedCourse);
					}else{
						localStorage.setItem("etlSelectCourse", 0);
					}

					if(deviceType && deviceType.length>0){
						localStorage.setItem("deviceType", deviceType);
					}else{
						localStorage.setItem("deviceType", 'android');
					}

					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';

					if(response.data.obj.courses && response.data.obj.courses.length>0){
						// Set cookie accountDetails to login on website
						// Cookies.set("accountDetails", JSON.stringify({
						// 	sid: response?.data?.obj?.studentId,
						// 	studentId: response?.data?.obj?.studentId,
						// 	loginId: response?.data?.obj?.loginId,
						// 	token: response?.data?.obj?.token,
						// 	studentName: response?.data?.obj?.studentName,
						// 	mobile: response?.data?.obj?.phoneNo,
						// 	email: response?.data?.obj?.emailId
						// }))

						// Set cookie token for the use on website
						// Cookies.set("token", `"${response?.data?.obj?.token}"`)

						// localStorage.setItem("etlStudentObj", JSON.stringify(response.data.obj));

						// get rating and review for opened course
						await saveCourseRating({
							index: response?.data?.obj?.openedCourse,
							courses: response?.data?.obj?.courses,
							websiteId: response?.data?.obj?.websiteId
						});
						
						localStorage.setItem("etlMyCourses", JSON.stringify(response.data.obj.courses));
						
						// if(response.data.obj.openedCourse!=null && response.data.obj.openedCourse>0){
						// 	localStorage.setItem("etlSelectCourse", response.data.obj.openedCourse);
						// }else{
						// 	localStorage.setItem("etlSelectCourse", 0);
						// }

						// if(deviceType && deviceType.length>0){
						// 	localStorage.setItem("deviceType", deviceType);
						// }else{
						// 	localStorage.setItem("deviceType", 'android');
						// }

						// document.getElementById('waitloginbtnid').style.display='none';
						// document.getElementById('loginbtnid').style.display='';
						
						window.location.href = "dashboard?ftu="+response.data.obj.firstTimeUser;

					}else{
						localStorage.setItem("etlMyCourses", "");
						window.location.href = "selectyourcourse";
						return false;
					}
				}else if(response.data.responseTxt=="ValidityFinished"){
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Validity Finished! Contact to customer care to Re-Activate your account.");			
					return false;	
				}else{
					document.getElementById('waitloginbtnid').style.display='none';
					document.getElementById('loginbtnid').style.display='';
					setShowAlert(true);
					setAlertMessage("Your user-id or password is invalid.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})
		}  
	}
	
	// Handles the 'Enter' key press event
	function onEnter(event) {
		// Check if the pressed key is 'Enter'
		if (event.key === 'Enter') {
			// If 'Enter' is pressed, trigger the login function
			login();
		}
	}

	// Handles the change in the login method (e.g., 'otp' or other methods)
	const handleLoginWith = (event) => {
		// Check if the selected login method is 'otp'
		if (event.target.value === 'otp') {
			// If 'otp' is selected, set a default password
			setPassword("xxx");
		} else {
			// If the selected login method is not 'otp', set password to null
			setPassword(null);
		}

		// Set the selected login method
		setLoginWith(event.target.value);
	};

	// Allows only numeric input in the input field
	function numberOnly(event) {
		// Use a regular expression to check if the pressed key is a number
		if (!/[0-9]/.test(event.key)) {
			// If the pressed key is not a number, prevent the default action
			event.preventDefault();
		} 
	}


	return (
		<div> 
			<MetaTags>
				<title>Sign in For Learner | EaseTolearn MY Study Room & Exam Prep</title>
				<meta name="description" content="Sign in For Learner | EaseTolearn MY Study Room & Exam Prep" />
			</MetaTags>
			<Box className="loginBGImg" style={{backgroundImage:"url('"+process.env.PUBLIC_URL+"/student_login_bg.jpg')", backgroundPosition: 'center', height: '100vh', overflow: 'hidden'}}>					
					<Stack spacing={2} sx={{ width: '100%' }}>
						<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
							<Alert onClose={hideAlert} variant="filled" severity="error" sx={{ width: '100%' }}>
								{alertMessage}
							</Alert>
						</Snackbar>
					</Stack>
				<Box>
					<Grid container style={{justifyContent: 'center'}} spacing={2}>
						<Grid item className="dhslogin" md={6} xs={12}>
							<Grid className="flex-container loginbox">								
								<Grid md={12} xs={12}>
								{
								(window.location.hostname==='localhost' || window.location.hostname==='student.easetolearn.com' || window.location.hostname==='easetolearn.com')?
								<img src={process.env.PUBLIC_URL+"/ease_to_learn_logo-white.png"} style={{height:80,marginTop:20,marginBottom:20}}  />
								:<img src={WHITE_LABEL_LOGO_URL+'/'+window.location.hostname.replace(/\./g,'-')+'.png'} style={{height:80,marginTop:20,marginBottom:20}}  />
								}
								</Grid>
								<Grid style={{textAlign:'left'}}>
									<Grid container>
										<Grid md={2} xs={12}>
											<FormLabel className='loginLabelA' id="row-radio-buttons-group-label" >Login with</FormLabel>
										</Grid>
										<Grid md={10} xs={12}>
											<RadioGroup
												row
												aria-labelledby="row-radio-buttons-group-label"
												name="radio-buttons-group"
												style={{marginLeft:10,marginTop:-10}}
												value={loginWith}
												onChange={handleLoginWith}									
											>
												<FormControlLabel className='loginLabelA' value="password" control={<Radio size='small' style={{color:'#FFF'}} />} label="Password" />
												<FormControlLabel className='loginLabelA' value="otp" control={<Radio size='small' style={{color:'#FFF'}} />} label="OTP" />
											</RadioGroup>
										</Grid>
									</Grid>
								</Grid>
								<Grid md={12} xs={12}>
									<div className='loginLabel' >{loginWith==='otp'?<>Mobile</>:<>User Id or Email or Mobile</>}</div>
									<TextField 
										placeholder={loginWith==='otp'?'Enter your mobile, OTP would be sent to verify':'User Id or Email or Mobile'}
										inputProps={loginWith==='otp'?{ maxLength: 10 }:{}} 
										onKeyPress={loginWith==='otp'?(event)=>{numberOnly(event)}:(event)=>{onEnter(event)}}
										onChange={event => setUserId(event.target.value)}
										style={{backgroundColor:'#FFF', borderRadius: 5}}
										color="warning"
										size="small"
										fullWidth	
										variant="outlined"
									/>
								</Grid>
								{loginWith==='password'?<>
								<Grid md={12} xs={12}>
									<div className='loginLabel' >Password</div>
									<TextField
										onKeyPress={(event)=>{onEnter(event)}}
										onChange={event => setPassword(event.target.value)}
										style={{backgroundColor:'#FFF', borderRadius: 5}}
										color="warning"
										size="small"
										type="password"											
										fullWidth	
										variant="outlined"							
									/>
								</Grid>																		
								<Grid md={12} xs={12}>
									<Link href="forgotpassword" className="loginfrgot" >Forgot Password?</Link>
								</Grid>
								</>:null}
								<Grid md={12} xs={12} style={{marginTop: -25}} >
									<Button id="loginbtnid" onClick={()=>{login()}} className="loginbtn" variant="contained">{loginWith==='password'?<>LOGIN</>:<>Get OTP</>}</Button>
									<LoadingButton 
										className="loginbtn"
										loading
										loadingPosition="start"											
										variant="outlined"
										color="secondary"
										id="waitloginbtnid" 
										style={{textTransform: 'none',display:'none'}}
									>
										Wait...
									</LoadingButton>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</div>
	);
}